<template>
  <BLayout :colors="$site.colors" :header-title="$t('pages.customer.reset.title')" :header-back-route="homeRoute">
    <BContainer class="mt-12">
      <div class="max-w-md mx-auto">
        <BErrors :errors="errors" class="mb-6" />

        <BCard :title="$t('pages.customer.reset.resetPassword')" class="mb-6">
          <template v-if="success">
            {{ $t('pages.customer.reset.resetSuccess') }}

            <div>
              <UButton class="mt-3 w-full" variant="soft" :to="{ path: '/customer' }">
                {{ $t('pages.customer.reset.loginHere') }} »
              </UButton>
            </div>
          </template>
          <form v-else @submit.prevent="reset">
            <UFormGroup :label="$t('pages.customer.reset.password')" class="mb-3">
              <BTextInput v-model="password" type="password" flat />
            </UFormGroup>

            <UFormGroup :label="$t('pages.customer.reset.confirm')" class="mb-3">
              <BTextInput v-model="confirm" type="password" flat />
            </UFormGroup>

            <UButton type="submit" :loading="resetting" class="mt-3" variant="soft" block>
              {{ $t('general.submit') }}
            </UButton>
          </form>
        </BCard>
      </div>
    </BContainer>
  </BLayout>
</template>

<script setup lang="ts">
import type { LocationQueryValue } from 'vue-router';

definePageMeta({
  tabs: ['user']
})

const { $api, $site, $i18n } = useNuxtApp()
const route = useRoute()

const resetCode = ref<LocationQueryValue | LocationQueryValue[] | null>(null)
const password = ref<string | null>(null)
const confirm = ref<string | null>(null)
const errors = ref<string[] | null>(null)
const resetting = ref<boolean>(false)
const success = ref<boolean>(false)

const homeRoute = computed(() => {
  return $site.homeRoute || { path: '/' }
})

onMounted(() => {
  resetCode.value = route.query.code
})

const reset = async () => {
  errors.value = []

  if (!password.value) {
    errors.value.push($i18n.t('pages.customer.reset.enterPasswordError'))
  }

  if (!confirm.value || confirm.value !== password.value) {
    errors.value.push($i18n.t('pages.customer.reset.confirmPasswordError'))
  }

  if (errors.value.length > 0) {
    return
  }

  errors.value = null
  resetting.value = true

  const response = await $api.auth.resetPassword($site.location, resetCode.value, password.value)

  if (response?.success) {
    success.value = true
  } else if (response?.errors) {
    errors.value = response?.errors
  }

  resetting.value = false
}
</script>
